"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isContentHubStencil = exports.contentHubStencilDefinition = void 0;
const properties_1 = require("../properties");
exports.contentHubStencilDefinition = {
    view: {
        label: 'Content Hub',
        category: 'content-collection',
        group: 'Collections',
        titleItems: ['title'],
        imageItems: ['featured-media'],
        contentAreas: [
            {
                name: 'main',
                items: [
                    'header-media',
                    'title',
                    'subheading',
                    'teaser',
                ],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'seo-title',
                            'social-title',
                            'featured-title',
                            'uri-title',
                            'preferred-label',
                            'featured-media',
                            'featured-video',
                        ],
                    },
                    {
                        name: 'Settings',
                        items: ['search-terms', 'standalone'],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                subAreas: [
                    {
                        name: 'Configuration',
                        items: ['exclude-content-tagged-with', 'include-content-tagged-with'],
                    },
                    {
                        name: 'Tagging',
                        items: [
                            'disciplines',
                            'content-categories',
                            'tag-events',
                            'tag-event-series',
                            'tag-persons',
                            'tag-teams',
                            'related-content',
                        ],
                    },
                ],
            },
        ],
        previewConfiguration: {
            hasPagePreview: true,
            hasFeatureCardPreview: true,
        },
    },
    content: {
        'content-categories': properties_1.contentCategoriesPropertyDefinition,
        disciplines: properties_1.disciplinesPropertyDefinition,
        'exclude-content-tagged-with': properties_1.excludeContentTaggedWithPropertyDefinition,
        'include-content-tagged-with': properties_1.includeContentTaggedWithPropertyDefinition,
        'featured-media': properties_1.featuredMediaPropertyDefinition,
        'featured-title': properties_1.featuredTitlePropertyDefinition,
        'featured-video': properties_1.featuredVideoPropertyDefinition,
        'header-media': properties_1.headerMediaPropertyDefinition,
        'preferred-label': properties_1.preferredLabelPropertyDefinition,
        'properties-container': properties_1.propertiesContainerPropertyDefinition,
        'related-content': properties_1.relatedContentPropertyDefinition,
        'search-terms': properties_1.searchTermsPropertyDefinition,
        'seo-title': properties_1.seoTitlePropertyDefinition,
        'social-title': properties_1.socialTitlePropertyDefinition,
        standalone: {
            ...properties_1.standalonePropertyDefinition,
            default: true,
        },
        subheading: properties_1.subheadingPropertyDefinition,
        'tag-events': properties_1.tagEventsPropertyDefinition,
        'tag-event-series': properties_1.tagEventSeriesPropertyDefinition,
        'tag-persons': properties_1.tagPersonsPropertyDefinition,
        'tag-teams': properties_1.tagTeamsPropertyDefinition,
        title: properties_1.titlePropertyDefinition,
        teaser: properties_1.teaserPropertyDefinition,
        'uri-title': properties_1.uriTitlePropertyDefinition,
    },
    localizations: [],
    roles: ['content-hub-manager'],
    spaces: [
        'brand-building-events',
        'racing-bulls',
        'rb-juniorteam',
        'rb-rookies',
        'redbull-racing',
        'redbull_com',
    ],
    name: 'content-hub',
};
const isContentHubStencil = (stencil) => {
    return stencil.name === exports.contentHubStencilDefinition.name;
};
exports.isContentHubStencil = isContentHubStencil;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29udGVudC1odWIuc3RlbmNpbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdGVuY2lscy9jb250ZW50LWh1Yi5zdGVuY2lsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUNBLDhDQXdCc0I7QUFFVCxRQUFBLDJCQUEyQixHQUFHO0lBQ3pDLElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxhQUFhO1FBQ3BCLFFBQVEsRUFBRSxvQkFBb0I7UUFDOUIsS0FBSyxFQUFFLGFBQWE7UUFDcEIsVUFBVSxFQUFFLENBQUMsT0FBTyxDQUFDO1FBQ3JCLFVBQVUsRUFBRSxDQUFDLGdCQUFnQixDQUFDO1FBQzlCLFlBQVksRUFBRTtZQUNaO2dCQUNFLElBQUksRUFBRSxNQUFNO2dCQUNaLEtBQUssRUFBRTtvQkFDTCxjQUFjO29CQUNkLE9BQU87b0JBQ1AsWUFBWTtvQkFDWixRQUFRO2lCQUNUO2FBQ0Y7WUFDRDtnQkFDRSxJQUFJLEVBQUUsTUFBTTtnQkFDWixRQUFRLEVBQUU7b0JBQ1I7d0JBQ0UsSUFBSSxFQUFFLFNBQVM7d0JBQ2YsS0FBSyxFQUFFOzRCQUNMLFdBQVc7NEJBQ1gsY0FBYzs0QkFDZCxnQkFBZ0I7NEJBQ2hCLFdBQVc7NEJBQ1gsaUJBQWlCOzRCQUNqQixnQkFBZ0I7NEJBQ2hCLGdCQUFnQjt5QkFDakI7cUJBQ0Y7b0JBQ0Q7d0JBQ0UsSUFBSSxFQUFFLFVBQVU7d0JBQ2hCLEtBQUssRUFBRSxDQUFDLGNBQWMsRUFBRSxZQUFZLENBQUM7cUJBQ3RDO29CQUNEO3dCQUNFLElBQUksRUFBRSxtQkFBbUI7d0JBQ3pCLEtBQUssRUFBRSxDQUFDLHNCQUFzQixDQUFDO3FCQUNoQztpQkFDRjthQUNGO1lBQ0Q7Z0JBQ0UsSUFBSSxFQUFFLFNBQVM7Z0JBQ2YsUUFBUSxFQUFFO29CQUNSO3dCQUNFLElBQUksRUFBRSxlQUFlO3dCQUNyQixLQUFLLEVBQUUsQ0FBQyw2QkFBNkIsRUFBRSw2QkFBNkIsQ0FBQztxQkFDdEU7b0JBQ0Q7d0JBQ0UsSUFBSSxFQUFFLFNBQVM7d0JBQ2YsS0FBSyxFQUFFOzRCQUNMLGFBQWE7NEJBQ2Isb0JBQW9COzRCQUNwQixZQUFZOzRCQUNaLGtCQUFrQjs0QkFDbEIsYUFBYTs0QkFDYixXQUFXOzRCQUNYLGlCQUFpQjt5QkFDbEI7cUJBQ0Y7aUJBQ0Y7YUFDRjtTQUNGO1FBQ0Qsb0JBQW9CLEVBQUU7WUFDcEIsY0FBYyxFQUFFLElBQUk7WUFDcEIscUJBQXFCLEVBQUUsSUFBSTtTQUM1QjtLQUNGO0lBQ0QsT0FBTyxFQUFFO1FBQ1Asb0JBQW9CLEVBQUUsZ0RBQW1DO1FBQ3pELFdBQVcsRUFBRSwwQ0FBNkI7UUFDMUMsNkJBQTZCLEVBQUUsdURBQTBDO1FBQ3pFLDZCQUE2QixFQUFFLHVEQUEwQztRQUN6RSxnQkFBZ0IsRUFBRSw0Q0FBK0I7UUFDakQsZ0JBQWdCLEVBQUUsNENBQStCO1FBQ2pELGdCQUFnQixFQUFFLDRDQUErQjtRQUNqRCxjQUFjLEVBQUUsMENBQTZCO1FBQzdDLGlCQUFpQixFQUFFLDZDQUFnQztRQUNuRCxzQkFBc0IsRUFBRSxrREFBcUM7UUFDN0QsaUJBQWlCLEVBQUUsNkNBQWdDO1FBQ25ELGNBQWMsRUFBRSwwQ0FBNkI7UUFDN0MsV0FBVyxFQUFFLHVDQUEwQjtRQUN2QyxjQUFjLEVBQUUsMENBQTZCO1FBQzdDLFVBQVUsRUFBRTtZQUNWLEdBQUcseUNBQTRCO1lBQy9CLE9BQU8sRUFBRSxJQUFJO1NBQ2Q7UUFDRCxVQUFVLEVBQUUseUNBQTRCO1FBQ3hDLFlBQVksRUFBRSx3Q0FBMkI7UUFDekMsa0JBQWtCLEVBQUUsNkNBQWdDO1FBQ3BELGFBQWEsRUFBRSx5Q0FBNEI7UUFDM0MsV0FBVyxFQUFFLHVDQUEwQjtRQUN2QyxLQUFLLEVBQUUsb0NBQXVCO1FBQzlCLE1BQU0sRUFBRSxxQ0FBd0I7UUFDaEMsV0FBVyxFQUFFLHVDQUEwQjtLQUN4QztJQUNELGFBQWEsRUFBRSxFQUFFO0lBQ2pCLEtBQUssRUFBRSxDQUFDLHFCQUFxQixDQUFDO0lBQzlCLE1BQU0sRUFBRTtRQUNOLHVCQUF1QjtRQUN2QixjQUFjO1FBQ2QsZUFBZTtRQUNmLFlBQVk7UUFDWixnQkFBZ0I7UUFDaEIsYUFBYTtLQUNkO0lBQ0QsSUFBSSxFQUFFLGFBQWE7Q0FDVyxDQUFBO0FBSXpCLE1BQU0sbUJBQW1CLEdBQUcsQ0FBQyxPQUFvQixFQUFnQyxFQUFFO0lBQ3hGLE9BQU8sT0FBTyxDQUFDLElBQUksS0FBSyxtQ0FBMkIsQ0FBQyxJQUFJLENBQUE7QUFDMUQsQ0FBQyxDQUFBO0FBRlksUUFBQSxtQkFBbUIsdUJBRS9CIn0=